import { State } from '../StateTypes';
import { Toasts, HasShownMultipackMessageFor } from './toastsTypes';

/**
 * Select toasts state slice
 *
 * @param toasts
 */
export const selectToasts = ({ toasts }: State): Toasts => toasts;

/**
 * Select has shown multipack message for
 *
 * @param state
 * @returns {string[]}
 */
export const selectHasShownMultipackMessageFor = (
  state: State
): HasShownMultipackMessageFor =>
  selectToasts(state).hasShownMultipackMessageFor;
